var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43316 4.30506L11.4283 2.30997C11.8399 1.89794 12.3287 1.57105 12.8667 1.34798C13.4047 1.12491 13.9814 1.01002 14.5638 1.00989C15.1462 1.00975 15.723 1.12437 16.2611 1.34719C16.7992 1.57001 17.2882 1.89667 17.7 2.30851C18.1118 2.72034 18.4385 3.20928 18.6613 3.7474C18.8841 4.28551 18.9987 4.86225 18.9986 5.44468C18.9985 6.0271 18.8836 6.60379 18.6605 7.1418C18.4374 7.67981 18.1106 8.1686 17.6985 8.58025L14.8484 11.4304C14.4367 11.8421 13.9479 12.1687 13.41 12.3915C12.8721 12.6143 12.2955 12.729 11.7133 12.729C11.131 12.729 10.5545 12.6143 10.0165 12.3915C9.47861 12.1687 8.98984 11.8421 8.57812 11.4304",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5654 15.6949L8.57035 17.69C8.15871 18.102 7.66992 18.4289 7.13191 18.652C6.5939 18.8751 6.01721 18.99 5.43479 18.9901C4.85236 18.9902 4.27562 18.8756 3.73751 18.6528C3.19939 18.43 2.71045 18.1033 2.29862 17.6915C1.88678 17.2796 1.56012 16.7907 1.3373 16.2526C1.11448 15.7145 0.999865 15.1377 1 14.5553C1.00014 13.9729 1.11502 13.3962 1.33809 12.8582C1.56116 12.3202 1.88805 11.8314 2.30008 11.4197L5.1502 8.56961C5.56192 8.1579 6.05069 7.83131 6.58862 7.6085C7.12654 7.38568 7.70309 7.271 8.28534 7.271C8.86759 7.271 9.44414 7.38568 9.98207 7.6085C10.52 7.83131 11.0088 8.1579 11.4205 8.56961",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.c8d119115052a2be32a469ddd3226144.svg";
export { ForwardRef as ReactComponent };